import styled from "styled-components";

export const ButtonContatct = styled.button`
    display: flex;
    align-items: center;
    gap: 8;
    color: "#FFFF";
    background-color: transparent;

    font-size: 14px;
    padding: 8px;
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    transition: all 0.2s ease-in-out;
 
    &:hover { 
        background-color: #FFFFFF;
        color: #20A85D;
    }
`;